import React from 'react';
import Masonry from '@mui/lab/Masonry';
import { useTheme } from '@mui/material';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { TABLET_SCREEN_SIZE } from '../../utils/constants/Constants.js';
import { StyledBox, MASONRY_SPACING, MASONRY_SPACING_MARGIN } from './CategoriesDropdownStyles.js';

var _a;
// hardcoding values for calculation purpose because
// we need to determine column width based on paper width
var XL_BREAKPOINT = 1400;
var LG_BREAKPOINT = 1200;
var MD_BREAKPOINT = TABLET_SCREEN_SIZE;
var COLUMNS_CONSTRAINT_CATEGORY_COUNT = 12;
var COLUMN_COUNT_BY_BREAKPOINT = (_a = {},
    _a[XL_BREAKPOINT] = 4,
    _a[LG_BREAKPOINT] = 4,
    _a[MD_BREAKPOINT] = 4,
    _a);
var BOX_HORIZONTAL_PADDING = 0;
var MASONRY_COLUMN_GAP = 20;
var NAV_COLUMN_SIDE_SPACING = Math.max((MASONRY_COLUMN_GAP - MASONRY_SPACING_MARGIN) / 2, 0);
var SCROLLBAR_WIDTH = 20;
var getNavConfig = function (_a) {
    var _b;
    var isCustomGrouped = _a.isCustomGrouped, topLevelNavItems = _a.topLevelNavItems;
    var windowWidth = (_b = window === null || window === void 0 ? void 0 : window.innerWidth) !== null && _b !== void 0 ? _b : MD_BREAKPOINT;
    var columnCount = COLUMN_COUNT_BY_BREAKPOINT[MD_BREAKPOINT];
    var containerWidth = Math.min(window.innerWidth * 0.9 - SCROLLBAR_WIDTH, 900); // 0.9 because all widgets have side padding of 5%
    if (windowWidth >= XL_BREAKPOINT) {
        columnCount = COLUMN_COUNT_BY_BREAKPOINT[XL_BREAKPOINT];
    }
    else if (windowWidth > LG_BREAKPOINT) {
        columnCount = COLUMN_COUNT_BY_BREAKPOINT[LG_BREAKPOINT];
    }
    if (!isCustomGrouped && topLevelNavItems <= COLUMNS_CONSTRAINT_CATEGORY_COUNT) {
        // design tweak for brands with less number of categories
        columnCount = COLUMN_COUNT_BY_BREAKPOINT[MD_BREAKPOINT];
    }
    var columnWidth = (containerWidth - BOX_HORIZONTAL_PADDING * 2 - MASONRY_COLUMN_GAP * (columnCount - 1)) / columnCount;
    return { columnCount: columnCount, columnWidth: columnWidth, containerWidth: containerWidth };
};
var CategoriesDropdown = function (_a) {
    var categoryNav = _a.categoryNav, isCustomGrouped = _a.isCustomGrouped, LinkComponent = _a.LinkComponent, handleCategoriesClose = _a.handleCategoriesClose;
    var theme = useTheme();
    var categories = _get(categoryNav, ['subNav'], []);
    if (!categories || _isEmpty(categories)) {
        return null;
    }
    var _b = getNavConfig({
        isCustomGrouped: isCustomGrouped,
        topLevelNavItems: categories.length,
    }), columnCount = _b.columnCount, columnWidth = _b.columnWidth, containerWidth = _b.containerWidth;
    return (React.createElement(StyledBox, { style: { width: containerWidth } },
        React.createElement(Masonry, { columns: columnCount, spacing: "".concat(MASONRY_SPACING, "px"), sx: { margin: 0, alignContent: 'space-between' } }, categories.map(function (group, groupIndex) {
            var _a;
            return group.route || group.subNav ? (React.createElement("div", { key: groupIndex, title: group.name, className: "wrap-text", style: {
                    width: columnWidth,
                    marginLeft: NAV_COLUMN_SIDE_SPACING,
                    marginRight: NAV_COLUMN_SIDE_SPACING,
                    paddingTop: groupIndex >= columnCount && isCustomGrouped ? '20px' : 0,
                } },
                group.route ? (React.createElement(LinkComponent, { to: group.route, className: "bold", style: {
                        fontSize: isCustomGrouped ? 16 : 14,
                        color: theme.palette.primary.main,
                        textDecoration: 'none',
                    }, onClick: handleCategoriesClose }, group.name)) : (React.createElement("span", { className: "group-name", title: group.name }, group.name)),
                isCustomGrouped &&
                    ((_a = group.subNav) === null || _a === void 0 ? void 0 : _a.map(function (category, catIndex) {
                        return category.route ? (React.createElement("div", { key: catIndex, title: category.name, style: { marginTop: 10, fontSize: 14 } },
                            React.createElement(LinkComponent, { to: category.route, style: { color: theme.palette.primary.main, textDecoration: 'none' }, onClick: handleCategoriesClose }, category.name))) : null;
                    })))) : null;
        }))));
};

export { CategoriesDropdown as default, getNavConfig };
//# sourceMappingURL=CategoriesDropdown.js.map
